import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type IManifestPro
 */

export const manifestProDetailsApi = async (manifestNumber: string) => {
  try {
    const response = await axios.get(`${getUrl(ApiType.MANIFEST_PRO_DETAILS)}/${manifestNumber}`);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.manifestProDetails, { badRequestOrder: "errorsFirst" });
  }
};
